import {inject, DOM, bindable} from 'aurelia-framework';

import * as SwiperJS from 'swiper';
import * as VimeoPlayer from '@vimeo/player';

@inject(DOM.Element)
export class Swiper {

  @bindable speed: number = 300;
  @bindable easing: string = 'ease-out';
  @bindable initialSlide: number = 0;
  @bindable slidesPerView: number = 1;
  @bindable spaceBetween: number = 0;
  @bindable loop: boolean = true;
  @bindable breakpoints: any = '';
  @bindable autoplay: any | boolean = false;
  @bindable delay: number = 3000;
  @bindable preloadImages: boolean = true;
  @bindable lazy: boolean = false;

  @bindable title: string = '';

  instance: string = '';
  swiperInner: Element;
  slides: Element;
  swiper: any;
  videos: Array<any> = [];

  constructor(private element: Element) {
    this.instance = this.instance_id();
  }

  bind(){

    if(this.breakpoints !== ''){
      this.breakpoints = this.breakpoints
          .split(';')
          .map((brk: string) => brk.split(','))
          .reduce((a: object, b: Array<string>) => {
            a[b[0]] = {
              slidesPerView: Number(b[1]),
              spaceBetween: Number(b[2]),
            };
            return a
      }, {});
    }
  }

  instance_id() {
    return 'xxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  attached() {

    if(this.autoplay) {
      this.autoplay = {
        delay: this.delay
      }
    }

    this.swiper = new SwiperJS(`#${this.instance}`, {
      speed: this.speed,
      initialSlide: Number(this.initialSlide),
      slidesPerView: Number(this.slidesPerView),
      spaceBetween: Number(this.spaceBetween),
      loop: Boolean(this.loop),
      centeredSlides: true,
      preloadImages: this.preloadImages,
      watchSlidesVisibility: true,
      lazy: this.lazy,
      navigation: {
        nextEl: `.control-${this.instance} .next`,
        prevEl: `.control-${this.instance} .prev`,
      },
      pagination: {
        el: `.control-${this.instance} .pagination` ,
        type: 'bullets',
      },
      autoplay: this.autoplay,
      on: {
        init:  () => {
          //console.log('swiper initialized');
          var videos = this.element.querySelectorAll('iframe, video');
          Array.prototype.forEach.call(videos,  (video) => {
            if (video.src.toLowerCase().includes('vimeo')) {
              const player = new VimeoPlayer(video);
              player.on('play', ($event) => { this.videoPlaying($event); });
              this.videos.push(player );
            }
          });

        },
        slideChangeTransitionEnd: () => {this.slideChanged();},
      },
      breakpoints: this.breakpoints
    });
  }

  slideChanged(){
    // const slide: Element = this.swiper.slides[this.swiper.activeIndex];
    // this.title = slide.getElementsByTagName('title')[0].firstChild.textContent;
    this.stopVideos();
  }

  stopVideos() {
    this.videos.forEach((video) => {
      video.getPaused().then((paused) => {
        if (!paused) {
          video.pause();
        }
      })
    })
  }

  clickedInSlide($event) {

  }

  videoPlaying(vimeo_play_event) {
    this.swiper.autoplay.stop();
  }


}
